import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { manageActions, userinfoActions, inboxActions, authActions, sentActions, alertActions } from '../../store/actions'
import { BsChevronRight, BsChevronDown } from 'react-icons/bs'
import Alert from '../../module/alert/Alert'
import Clipboard from 'react-clipboard.js' //2021.05  Bootstrap Icons (>∨)

const ServiceDashboard = (props) => {
  const [state, setState] = useState({})
  const [usrInfo, setUsrInfo] = useState({})

  const [countInfo, setCountInfo] = useState({
    countALL: 0,
  })

  let uri = ['/', '/service/inbox', '/service/sent']

  useEffect(() => {
    props.load()
    props.getGroupInfo()
    props.readOrgInboxList()
    props.readOrgSentList()
  }, [])

  // 초기 사업자 정보 조회 성공 후
  useEffect(() => {
    setState({
      ...state,
      ...props.groupInfo,
    })
  }, [props.groupInfo])

  useEffect(() => {
    setUsrInfo({
      ...usrInfo,
      ...props.userInfo,
    })
  }, [props.userInfo])

  useEffect(() => {
    setCountInfo({
      ...countInfo,
      countInbox: props.inboxInfo?.ALL,
      sentInbox: props.sentInfo?.ALL,
      tempCount: props.sentInfo?.TEMP + props.inboxInfo?.TEMP,
    })
  }, [props.inboxInfo, props.sentInfo])
  const ewalletIdCopy = () => {
    props.error({ title: '확인', message: '주소가 복사되었습니다.' })
  }
  return (
    <React.Fragment>
      <div className="dashBoard">
        <div className="accordion-area">
          {/* dash board */}

          <div className="profile-article">
            {/* 아코디언-내정보 */}
            <div className="accordion-head myProfile">
              <Link to="/change/info" title="개인정보변경" className="myProfile-link">
                <span className="myProfile-image"></span>
                <span className="myProfile-info">
                  <strong>{state.groupName}</strong>
                  <span className="myProfile-info-name">{state.memberName}</span>
                </span>
              </Link>
              <div className="myProfile-right">
                <Link className="myProfile-link-btn" to="#">
                  <span className="ic-link-copy" onClick={ewalletIdCopy}>
                    <Clipboard className="text btn-copy" data-clipboard-text={usrInfo.ewalletId}>
                      내지갑 주소복사
                    </Clipboard>
                  </span>
                </Link>
              </div>
            </div>

            <div className="accordion-contents ">
              <div className="mySummary">
                <div className="mySummary-total">
                  <ul className="mySummary-total-link">
                    <li>
                      <a title="받은문서" href={uri[1]}>
                        <span className="ic-dash-my"></span>받은문서 :{' '}
                        <em>
                          <strong>{countInfo.countInbox}</strong>건
                        </em>
                      </a>
                    </li>
                    <li>
                      <a title="보낸문서" href={uri[2]}>
                        <span className="ic-dash-send"></span>보낸문서 :{' '}
                        <em>
                          <strong>{countInfo.sentInbox}</strong>건
                        </em>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* end of 아코디언-내정보 */}
          </div>

          {/* end of dash board */}
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userinfo?.data,
    groupInfo: state.manage?.data,
    inboxList: state.inbox?.inboxList?.list,
    SentList: state.sent?.SentList?.list,
    inboxInfo: state.inbox?.inboxOrgList?.count,
    sentInfo: state.sent?.SentOrgList?.count,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  error: alertActions.error,
  getGroupInfo: manageActions.getGroupInfo,
  readOrgInboxList: inboxActions.readOrgInboxList,
  readOrgSentList: sentActions.readOrgSentList,
}

export default connect(mapStateToProps, actionCreators)(ServiceDashboard)
